import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

// Components
import Header from '../../components/Header/index';
import Title from '../../components/Title/index';

// Images
import RfactorIcon from '../../assets/images/rfactorIcon.png';
import ArmaIcon from '../../assets/images/armaIcon.png';

// Firebase
import { db, storage, firebaseApp } from '../../utils/firebaseConfig';

// Tabelas
import { DataGrid, ColDef, ValueFormatterParams } from '@material-ui/data-grid';

// Ícones material-ui
import { Delete, CloudDownload, CloudUpload, Details, Close, InsertDriveFile } from '@material-ui/icons';
import {
    IconButton, Tooltip, Fab, Dialog, DialogActions, DialogTitle, DialogContent, DialogContentText, Button,
    List, ListItem, ListItemText, ListItemIcon, ListItemSecondaryAction,
    Typography, Drawer, Divider, Snackbar, TextField
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';

// Context
import AuthContext from '../../Context/context';

import './style.css'

function Rfactor() {
    let params: any = useParams();
    const { isAdmin, currentUser } = useContext(AuthContext);

    const [categoria, setCategoria] = useState<any>(null);

    const [mods, setMods] = useState<any>([]);
    const [mod, setMod] = useState<any>(null);

    // Alert's
    const [alert, setAlert] = useState('');

    const [openAlert, setShowAlert] = useState(false);

    const showAlert = () => setShowAlert(true);

    const hideAlert = () => setShowAlert(false);

    // Drawer
    const [openDrawerRight, setOpenDrawerRight] = useState(false);

    const showDrawerRight = () => setOpenDrawerRight(true);

    const hideDrawerRight = () => setOpenDrawerRight(false);

    // Dialogs
    const [addDialog, setShowAdd] = useState(false);
    const [deleteDialog, setShowDelete] = useState(false);

    const showAdd = () => setShowAdd(true);
    const showDelete = () => setShowDelete(true);

    const hideAdd = () => setShowAdd(false);
    const hideDelete = () => setShowDelete(false);

    // Forms
    const [nomeMod, setNomeMod] = useState('');
    const [downloadUrl, setDownloadUrl] = useState('');

    useEffect(() => {
        GetCategoriaAndMods();
    }, []);

    // Get das categorias e chamamento do método para trazer mods pela categoria
    const GetCategoriaAndMods = () => {
        let collection = '';

        if (params.jogo === 'rfactor')
            collection = 'CategoriasModsRfactor'
        else if (params.jogo === 'arma')
            collection = 'CategoriasModsArma'
        else {
            setAlert('Este armazenamento não existe. Por favor, corrija o nome da coleção do mod na URL.')
            return showAlert();
        }

        db.collection(collection).doc(params.categoria).onSnapshot(resp => {
            if (resp.exists) {
                let cat = {
                    id: resp.id,
                    nome: resp.data()?.nome,
                    qtdMods: resp.data()?.qtdMods
                }
                setCategoria(cat);
                GetModsByCategoria(cat);
            }
        })
    }

    // Get dos mods por categoria específica
    const GetModsByCategoria = (cat: any) => {
        let collection = '';

        if (params.jogo === 'rfactor')
            collection = 'RfactorModsLinks'
        else if (params.jogo === 'arma')
            collection = 'ArmaModsLinks'
        else {
            setAlert('Este armazenamento não existe. Por favor, corrija o nome da coleção do mod na URL.')
            return showAlert();
        }

        db.collection(collection).where('categoria', '==', cat.nome).onSnapshot(resp => {
            let mds = resp.docs.map((m: any) => {
                return {
                    id: m.id,
                    nome: m.data().nome,
                    enviadoPor: m.data().enviadoPor,
                    categoria: m.data().categoria,
                    timeUpdated: m.data().timeUpdated,
                    downloadUrl: m.data().downloadUrl
                }
            });

            setMods(mds);
        })
    }

    const DownloadMod = async (url: any) => {
        // Cria um link
        let fileLink = document.createElement('a');

        // Adiciona no href a url de download do arquivo
        fileLink.href = url;

        fileLink.target = "_blank";

        // função de 'click' no link para envia-lo a página de download do mod
        fileLink.click();
    }

    // Upload
    const UploadMod = () => {
        let collectionCat = '';
        let collectionMod = '';

        if (params.jogo === 'rfactor') {
            collectionCat = 'CategoriasModsRfactor'
            collectionMod = 'RfactorModsLinks'
        }
        else if (params.jogo === 'arma') {
            collectionCat = 'CategoriasModsArma'
            collectionMod = 'ArmaModsLinks'
        }
        else {
            setAlert('Este armazenamento não existe. Por favor, corrija o nome da coleção do mod na URL.')
            return showAlert();
        }

        if (nomeMod.length === 0 ||
            downloadUrl.length === 0) {
            setAlert('Preencha todos os campos para registrar um novo Mod.')
            return showAlert();
        }

        hideAdd();
        // Cadastra na coleção o arquivo que foi enviado
        db.collection(collectionMod).add({
            nome: nomeMod,
            downloadUrl: downloadUrl,
            enviadoPor: currentUser?.email,
            categoria: categoria.nome,
            timeUpdated: firebaseApp.firestore.FieldValue.serverTimestamp()
        })
            .catch(err => {
                setAlert('Houve um erro na criação do registro do Mod na Cloud Firestore.')
                return showAlert();
            })

        // Atualiza categorias para adicionar nova quantidade de mods
        db.collection(collectionCat).doc(categoria.id).update({
            qtdMods: mods.length + 1,
        })
            .then(resp => {
                LimparCampos();
            })
            .catch(err => {
                setAlert('Houve um erro ao atualizar nova quantidade de mods da categoria.')
                return showAlert();
            })
    }

    // Delete
    const DeleteMod = () => {
        let collectionCat = '';
        let collectionMod = '';

        if (params.jogo === 'rfactor') {
            collectionCat = 'CategoriasModsRfactor'
            collectionMod = 'RfactorModsLinks'
        }
        else if (params.jogo === 'arma') {
            collectionCat = 'CategoriasModsArma'
            collectionMod = 'ArmaModsLinks'
        }
        else {
            setAlert('Este armazenamento não existe. Por favor, corrija o nome da coleção do mod na URL.')
            return showAlert();
        }

        // Deleta o registro do arquivo no firestore
        db.collection(collectionMod).doc(mod.id).delete()
            .catch(err => {
                console.log('Houve um erro ao deletar o registro do mod no FireStore.')
            })

        // Atualiza categorias para alterar qtd de mods
        db.collection(collectionCat).doc(categoria.id).update({
            qtdMods: mods.length - 1,
        })
            .catch(err => {
                console.log('Houve um erro ao atualizar nova quantidade de mods da categoria.');
            })

        setMod(null);
        hideDelete();

    }

    const LimparCampos = () => {
        setNomeMod('');
        setDownloadUrl('');
    }

    const columns: ColDef[] = [
        { field: 'nome', headerName: 'Nome do Mod', width: 320 },
        { field: 'enviadoPor', headerName: 'Enviado por', width: 320 },
        {
            field: 'actions',
            headerName: 'Ações',
            width: 170,
            renderCell: (params: ValueFormatterParams) => (
                <div style={{ margin: '0 auto' }}>
                    <Tooltip title="Download" onClick={() => { DownloadMod(params.row.downloadUrl) }}>
                        <IconButton>
                            <CloudDownload />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Ver Detalhes" onClick={() => {
                        setMod(params.row);
                        showDrawerRight();
                    }}>
                        <IconButton>
                            <Details />
                        </IconButton>
                    </Tooltip>
                    {
                        isAdmin &&
                        <Tooltip title="Delete" onClick={() => {
                            setMod(params.row);
                            showDelete();
                        }}>
                            <IconButton>
                                <Delete />
                            </IconButton>
                        </Tooltip>
                    }
                </div>
            )
        }
    ];

    return (
        <div>
            <Header />

            {
                (params.jogo === 'rfactor' && categoria?.nome) &&
                <Title img={RfactorIcon} title={`Categoria: ${categoria.nome}`} />
            }
            {
                (params.jogo === 'arma' && categoria?.nome) &&
                <Title img={ArmaIcon} title={`Categoria: ${categoria.nome}`} />
            }


            <div style={{ marginTop: '3em', marginBottom: '3em' }}>
                <div className="table-container" style={{ height: 500, margin: '0 auto' }}>
                    <DataGrid pagination rows={mods} columns={columns} pageSize={5} rowsPerPageOptions={[5, 10, 25, 50]}
                    />
                </div>
            </div>

            {
                isAdmin &&
                <div>
                    <div style={{ display: 'flex', justifyContent: 'center', margin: '2em 0' }}>
                        <Tooltip title="Registrar Mod" onClick={() => {
                            showAdd();
                        }}>
                            <Fab color="inherit">
                                <CloudUpload />
                            </Fab>
                        </Tooltip>
                    </div>
                </div>
            }

            <Drawer anchor="right" open={openDrawerRight} onClose={() => {
                hideDrawerRight();
                setMod(null);
            }}>
                {
                    mod !== null &&
                    <List style={{ width: '20em' }}>
                        <ListItem style={{ margin: '1.5em 0' }}>
                            <ListItemIcon>
                                <InsertDriveFile />
                            </ListItemIcon>
                            <Typography component="h5" variant="h5">
                                {mod.nome.length > 14 ? mod.nome.substring(0, 14) + '...' : mod.nome}
                            </Typography>
                            <ListItemSecondaryAction style={{ display: 'flex', alignItems: 'center' }} >
                                <IconButton onClick={() => {
                                    hideDrawerRight();
                                    setMod(null);
                                }}>
                                    <Close />
                                </IconButton>
                            </ListItemSecondaryAction>
                        </ListItem>
                        <Divider />
                        <ListItem>
                            <ListItemText
                                primary="Nome"
                                secondary={mod.nome.length > 20 ? mod.nome.substring(0, 20) + '...' : mod.nome}
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemText
                                primary="Categoria do Mod"
                                secondary={mod.categoria}
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemText
                                primary="Criado"
                                secondary={new Date(mod.timeUpdated.toDate()).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' })}
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemText
                                primary="Enviado por"
                                secondary={mod.enviadoPor}
                            />
                        </ListItem>
                    </List>
                }
            </Drawer>

            {/* Modal para Upload de mod */}
            <Dialog open={addDialog} aria-labelledby="form-dialog-title" onClose={() => {
                hideAdd();
                //limparCampos();
            }}>
                <DialogTitle id="form-dialog-title">Upload de novo Mod</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Para fazer o upload de um novo Mod, preencha os campos abaixo:
                    </DialogContentText>
                    <TextField
                        autoFocus
                        id="nome"
                        margin="dense"
                        label="Coloque o nome do Mod"
                        type="text"
                        fullWidth
                        value={nomeMod}
                        onChange={event => setNomeMod(event.target.value)}
                    />

                    <TextField
                        id="email"
                        margin="dense"
                        label="Insira a URL de download do Mod"
                        type="email"
                        fullWidth
                        value={downloadUrl}
                        onChange={event => setDownloadUrl(event.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={() => {
                        hideAdd();
                        //limparCampos();
                    }} >
                        Fechar
                    </Button>
                    <Button color="primary" onClick={(e) => {
                        UploadMod();
                    }}>
                        Registrar Mod
                    </Button>
                </DialogActions>
            </Dialog>
            {/* FIM do Modal para Upload de mod */}

            {/* Modal para Deletar Mod */}
            <Dialog open={deleteDialog} aria-labelledby="form-dialog-title2" onClose={() => {
                hideDelete();
                setMod(null);
            }}>
                <DialogTitle id="form-dialog-title2" >Deletar Mod</DialogTitle>
                <DialogContent>
                    <DialogContentText color="error">
                        Você tem certeza que deseja deletar o Mod "{mod?.nome}"?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={() => {
                        hideDelete();
                        setMod(null);
                    }}>
                        Cancelar
                    </Button>
                    <Button color="primary" onClick={() => {
                        DeleteMod();
                    }}>
                        Deletar
                    </Button>
                </DialogActions>
            </Dialog>
            {/* FIM do Modal para Deletar Mod */}

            <Snackbar open={openAlert} autoHideDuration={12000} onClose={hideAlert}>
                <Alert onClose={hideAlert} severity="error" variant="filled">
                    {alert}
                </Alert>
            </Snackbar>
        </div>
    );
}

export default Rfactor;
